/** Cloudinary folder used for space images across MillionSpaces environments. */
const SPACE_IMAGE_FOLDER = 'ms-singapore';

/**
 * Normalises a Cloudinary value (full URL or public id) to a public id such as
 * "ms-singapore/at8feredo3ey0sqxaran" for use with IMAGES_BASE_URL.
 */
export const extractCloudinaryPublicId = (value) => {
  if (!value || typeof value !== 'string') return null;
  const trimmed = value.trim();
  if (!trimmed) return null;

  if (!/^https?:\/\//i.test(trimmed)) {
    return trimmed.replace(/^\/+/, '');
  }

  try {
    const { pathname } = new URL(trimmed);
    const folderMarker = `/${SPACE_IMAGE_FOLDER}/`;
    const folderIdx = pathname.indexOf(folderMarker);
    if (folderIdx !== -1) {
      return pathname.slice(folderIdx + 1).split('?')[0] || null;
    }

    const parts = pathname.split('/').filter(Boolean);
    const folderPartIdx = parts.indexOf(SPACE_IMAGE_FOLDER);
    if (folderPartIdx !== -1) {
      return parts.slice(folderPartIdx).join('/').split('?')[0] || null;
    }
  } catch {
    return null;
  }

  return null;
};

/**
 * Picks the first resolvable public id from common agent/search image fields.
 */
export const resolveSpaceImagePublicId = (space = {}) => {
  const candidates = [
    space.image,
    space.primaryImageUrl,
    ...(Array.isArray(space.imageUrls) ? space.imageUrls : []),
  ];

  for (const candidate of candidates) {
    const publicId = extractCloudinaryPublicId(candidate);
    if (publicId) return publicId;
  }

  return null;
};
